export function sessionStorageGetItem<TItem>(item: string): TItem | null;
export function sessionStorageGetItem<TItem>(item: string, fallback: TItem): TItem;
export function sessionStorageGetItem<TItem>(item: string, fallback?: TItem): TItem | null {
  if (item in sessionStorage) {
    return JSON.parse(sessionStorage.getItem(item) || '');
  }

  return fallback ?? null;
}
